import React from 'react';
export var MixpanelContext = React.createContext({
    mixpanel: { track: function () { } },
    productPrefix: ''
});
export function MixpanelProvider(_a) {
    var children = _a.children, mixpanel = _a.mixpanel, productPrefix = _a.productPrefix;
    var mixpanelInstance = mixpanel || window.mixpanel;
    if (!mixpanelInstance) {
        throw new Error('Mixpanel is required, but was not provided as a parameter and does not exist on window.');
    }
    return (React.createElement(MixpanelContext.Provider, { value: { mixpanel: mixpanelInstance, productPrefix: productPrefix } }, children));
}
export function dummyMixpanel() {
    return {
        track: function (_action) {
            console.log("Dummy Mixpanel tracking action: ".concat(_action));
        }
        // Only include methods you want to mock
    };
}
//# sourceMappingURL=useMixpanel.js.map